module.exports = __webpack_public_path__ + "static/media/зу.bcbf06a8.mp3";